var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useTheme } from '../../../../themes';
import CircleCheck from '../../../../assets/icons/CircleCheck';
import { Typography } from '../../../Typography';
import { Checkbox } from '../../../Checkbox';
import * as S from './styles';
var filterOptions = function (options, inputValue) {
    if (!inputValue)
        return options;
    var filtered = options.filter(function (option) {
        var _a;
        if (option.section)
            return true;
        return (_a = option.label) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase());
    });
    var cleanArr = filtered.filter(function (option, index) {
        var _a;
        var nextIndex = index + 1;
        if ((option === null || option === void 0 ? void 0 : option.section) && index === filtered.length - 1)
            return false;
        if ((_a = filtered === null || filtered === void 0 ? void 0 : filtered[nextIndex]) === null || _a === void 0 ? void 0 : _a.section)
            return false;
        return true;
    });
    return cleanArr;
};
var parseOptions = function (options, inputValue) {
    var parsedOptions = options.reduce(function (prev, cur) {
        if (cur.section) {
            var sectionOptions = cur.options
                ? parseOptions(cur.options)
                : [];
            return __spreadArray(__spreadArray(__spreadArray([], prev, true), [{ section: cur.section }], false), sectionOptions, true);
        }
        return __spreadArray(__spreadArray([], prev, true), [cur], false);
    }, []);
    return inputValue ? filterOptions(parsedOptions, inputValue) : parsedOptions;
};
export var DropdownBase = function (_a) {
    var options = _a.options, containerProps = _a.containerProps, itemProps = _a.itemProps, itemTypographyProps = _a.itemTypographyProps, sectionProps = _a.sectionProps, sectionTypographyProps = _a.sectionTypographyProps, onClickOption = _a.onClickOption, value = _a.value, noOptionsText = _a.noOptionsText, inputValue = _a.inputValue, scrollYAtHeight = _a.scrollYAtHeight;
    var _b = useTheme(), brand = _b.brand, neutrals = _b.neutrals;
    var parsedOptions = useMemo(function () { return parseOptions(options, inputValue); }, [options]);
    var renderOptions = useMemo(function () {
        if (!parsedOptions.length) {
            return (_jsx(S.Item, __assign({ "data-testid": "select-empty-options", isNoOptions: true }, itemProps, { children: _jsx(Typography, __assign({}, itemTypographyProps, { children: noOptionsText })) })));
        }
        var multiSelect = !!Array.isArray(value);
        var checkIsSelected = function (option) {
            if (!multiSelect)
                return option.section ? false : (value === null || value === void 0 ? void 0 : value.value) === option.value;
            return value.some(function (item) { return item.value === option.value; });
        };
        return (_jsx(_Fragment, { children: parsedOptions.map(function (option, index) {
                var isSelected = checkIsSelected(option);
                var multiSelectColor = isSelected
                    ? { color: brand.color.status.neutral1 }
                    : { color: neutrals.gray7 };
                return (_jsxs(S.Item, __assign({ isSelected: isSelected, isSection: !!option.section, onClick: function () { return !option.section && onClickOption(option); } }, (option.section ? sectionProps : itemProps), { children: [!option.section && multiSelect && (_jsx(Checkbox, { "data-testid": "click-checkbox-select-item-".concat(index), mRight: "nano", checked: isSelected, onChange: function () { return ({}); } })), _jsx(Typography, __assign({ "data-testid": "click-select-item-".concat(index) }, (option.section
                            ? sectionTypographyProps
                            : itemTypographyProps), (multiSelect && multiSelectColor), { children: (option === null || option === void 0 ? void 0 : option.label) || (option === null || option === void 0 ? void 0 : option.section) })), isSelected && !multiSelect && (_jsx(S.CheckIconContainer, { children: _jsx(CircleCheck, { fill: "inherit" }) }))] }), JSON.stringify(option.value || option.section)));
            }) }));
    }, [parsedOptions]);
    var renderItems = useMemo(function () {
        return (_jsx(S.Container, __assign({ scrollYAtHeight: scrollYAtHeight }, containerProps, { children: renderOptions })));
    }, [renderOptions]);
    return renderItems;
};
export var Dropdown = React.memo(DropdownBase);
